export default __webpack_public_path__ + "static/media/ailos-logo.60e58525.png";